// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";

import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";

// Material Kit 2 React page layout routes
import routes from "routes";

import { Helmet } from "react-helmet-async";
// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function CursosPage() {
  return (
    <>
      <Helmet>
        <title>Cursos y Capacitación Profesional | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Próximamente: Cursos de panadería, pastelería y capacitación profesional con certificación oficial en San Juan. Formate con el Sindicato de Panaderos."
        />

        <meta
          name="keywords"
          content="cursos panaderia san juan, aprender pasteleria, capacitacion laboral panaderos, escuela de panaderia, cursos con salida laboral san juan"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Capacitación Profesional - Sindicato Panaderos San Juan"
        />
        <meta
          property="og:description"
          content="Estamos preparando los mejores cursos de capacitación para el sector panadero. ¡Muy pronto más novedades!"
        />
        <meta property="og:type" content="website" />
        {/* Puedes usar la misma imagen de fondo bgImage para el OG si la tienes en una URL pública */}

        <link rel="canonical" href="https://www.sindicatopanaderossanjuan.com.ar/cursos" />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            <Card>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  La sección de Cursos está en construccion <br /> proximamente estará habilitada.
                </MKTypography>
                <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                  <Grid item xs={2}>
                    <MKTypography component={MuiLink} href="#" variant="body1" color="white">
                      <FacebookIcon color="inherit" />
                    </MKTypography>
                  </Grid>
                  <Grid item xs={2}>
                    <MKTypography component={MuiLink} href="#" variant="body1" color="white">
                      <GitHubIcon color="inherit" />
                    </MKTypography>
                  </Grid>
                  <Grid item xs={2}>
                    <MKTypography component={MuiLink} href="#" variant="body1" color="white">
                      <GoogleIcon color="inherit" />
                    </MKTypography>
                  </Grid>
                </Grid>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
        <SimpleFooter light />
      </MKBox>
    </>
  );
}

export default CursosPage;
